import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Trash = ({ width = '20', height = '20', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <rect width="20" height="20" rx="4" />
    <path
      className="trash-icon-path"
      d="M11.6113 1.42871C12.5973 1.42871 13.3972 2.23548 13.3975 3.21387V4.28613H17.8564C18.2495 4.28613 18.5713 4.60714 18.5713 5C18.5713 5.39286 18.2495 5.71387 17.8564 5.71387H16.5488L15.6133 16.9287C15.5418 17.8501 14.7697 18.5713 13.8408 18.5713H6.15918C5.23751 18.5713 4.45839 17.8431 4.38672 16.9219L3.45117 5.71387H2.14355C1.75053 5.71387 1.42871 5.39286 1.42871 5C1.42871 4.60714 1.75053 4.28613 2.14355 4.28613H6.60938V3.21387C6.6096 2.22843 7.40964 1.42885 8.39551 1.42871H11.6113ZM5.81641 16.8076C5.83092 16.993 5.9805 17.1356 6.16602 17.1357H13.8408C14.0266 17.1357 14.177 16.993 14.1914 16.8145L14.1982 16.8076L15.127 5.70703H4.88672L5.81641 16.8076ZM8.39551 8.03613C8.78834 8.03616 9.10938 8.35716 9.10938 8.75V14.1074C9.10922 14.5001 8.78825 14.8213 8.39551 14.8213C8.00274 14.8213 7.68179 14.5002 7.68164 14.1074V8.75C7.68164 8.35714 8.00265 8.03613 8.39551 8.03613ZM11.6113 8.03613C12.0041 8.03626 12.3252 8.35722 12.3252 8.75V14.1074C12.325 14.5001 12.004 14.8212 11.6113 14.8213C11.2186 14.8213 10.8966 14.5002 10.8965 14.1074V8.75C10.8965 8.35714 11.2185 8.03613 11.6113 8.03613ZM8.39551 2.85742C8.19568 2.85755 8.0383 3.01415 8.03809 3.21387V4.28613H11.9688V3.21387C11.9685 3.01407 11.8113 2.85742 11.6113 2.85742H8.39551Z"
      fill="#3063FD"
    />
  </svg>
)

export default withDefaultStyles(Trash)
